import {ReactNode} from 'react';

import View from 'components/Common/View';

type Props = {
  children: ReactNode;
};

const Actions = ({children}: Props) => {
  return <View className="actions">{children}</View>;
};

export default Actions;
